module.exports = __webpack_public_path__ + "img/gal_8.281e43d6.png";